
const generateActionType = (type) => ({
  REQUEST: `${type}_REQUEST`,
  SUCCESS: `${type}_SUCCESS`,
  FAILURE: `${type}_FAILURE`
})

// Error
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'

// Language
export const CHANGE_LAUGUAGE = 'CHANGE_LAUGUAGE'

// Place
export const PLACE = generateActionType('GET_PLACE')
export const POPULAR_PLACE = generateActionType('GET_POPULAR_PLACE')
export const PLACE_DETAILS = generateActionType('PLACE_DETAILS')

// Food
export const FOOD = generateActionType('FOOD')
export const POPULAR_FOOD = generateActionType('POPULAR_FOOD')
export const FOOD_DETAILS = generateActionType('FOOD_DETAILS')

// Shopping
export const SHOPPING = generateActionType('SHOPPING')
export const POPULAR_SHOPPING = generateActionType('POPULAR_SHOPPING')
export const SHOPPING_DETAILS = generateActionType('SHOPPING_DETAILS')

// Otop
export const OTOP = generateActionType('OTOP')
export const POPULAR_OTOP = generateActionType('POPULAR_OTOP')
export const OTOP_DETAILS = generateActionType('OTOP_DETAILS')
// Otop Cart
export const OTOP_ADD_TO_CART = 'OTOP_ADD_TO_CART'
export const OTOP_REMOVE_FROM_CART = 'OTOP_REMOVE_FROM_CART'
export const OTOP_CHECKOUT = generateActionType('OTOP_CHECKOUT')

// News
export const NEWS = generateActionType('NEWS')
export const POPULAR_NEWS = generateActionType('POPULAR_NEWS')
export const NEWS_DETAILS = generateActionType('NEWS_DETAILS')

// Hotels
export const HOTELS = generateActionType('HOTELS')
export const POPULAR_HOTELS = generateActionType('POPULAR_HOTELS')
export const HOTELS_DETAILS = generateActionType('HOTELS_DETAILS')

// AREAS
export const AREAS = generateActionType('AREAS')
export const CATEGORY = generateActionType('CATEGORY')

// Check lasted
export const CHECK_LASTED = generateActionType('CHECK_LASTED')

// Bookmark
export const ADD_BOOKMARK = 'ADD_BOOKMARK'
export const DELETE_BOOKMARK = 'DELETE_BOOKMARK'
export const CLEAR_BOOKMARK = 'CLEAR_BOOKMARK'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js